export const WizardPrices = {
  Lte3000: 'lte3000',
  Gte3000lte5000: 'gte3000lte5000',
  Gte5000lte7000: 'gte5000lte7000',
  Gte7000lte10000: 'gte7000lte10000'
}
